import styled from 'styled-components';

import logo from "../../../assets/images/logo-memed-novo.svg"

const Logo = styled.img.attrs({
  src: logo,
})`
  display: block;
  width: 178px;
  height: 52px;
`;

export default Logo;
